module.exports = __webpack_public_path__ + "static/interior00-c418d47ade5f050ac0d5808221b07493.jpg";